import styled from 'styled-components';

export const Container = styled.div`
width: 100%;
min-height: calc(100vh - 90px);
height:  calc(100vh);
top:0;
 position: fixed;
display: flex;
justify-content: center;
flex-direction: column;
margin: 0 auto; 
  .dimension-horizon{
              height:  calc(100vh - 130px);
              display: flex;
       flex-direction: column;
          justify-content: center;
}
img {
  max-height:  calc(100vh - 230px);
}
iframe {
  height: calc(100vh - 190px);
  margin-top: 30px !important;
}
img, iframe {
    width: auto;
    margin: 0 auto;
}
iframe {
    border: 0px;
    width: calc(100% - 180px);
    position: relative;
  z-index: 99;

}
video {
  position: relative;
  z-index: 99;
}
.iframe--container {
 
}
.vert {
      max-height: calc(100vh - 190px);
      width: auto;
      margin-top: 30px;
}
h2 {
  margin: 0 auto;
  padding-top:0 !important;
  line-height: 12px;
  font-size: 10px !important;
  font-family: "Sackers";
  letter-spacing: 2px;
  text-transform: uppercase;
}
h1 {
  margin: 0px auto 0;
  padding: 0px 0px 0;
  font-weight: 100;
  max-width: calc(100vw - 200px);
  font-size: 115px;
  z-index: 1;
  position: relative;
  /* cursor: pointer; */
  line-height: 120px;
} 

p {
  margin: 60px auto;
      padding: 30px 60px 0;
      font-weight: 100;
      max-width: calc(100vw - 300px);
      font-size: 30px;
      z-index: 1;
      position: relative;
      /* cursor: pointer; */
      line-height: 40px;
}

@media screen and (max-width: 786px) {
   height:  calc(50vh);
    p {
      margin: 30px auto;
      padding: 0px 0px 0;
      max-width: calc(100vw - 60px);
      font-size: 20px;
      line-height: 1.25em;
    }
    h1 {
      margin: 0px auto;
      padding: 0px 0px 0;
      font-weight: 100;
      max-width: calc(100vw - 60px);
      font-size: 40px;
      line-height: 1.25em;
  }  
  h2 {
    margin: 0 auto !important;
  }
  img, iframe {
    width: 100%;
    
  }
  iframe{ 
    height: 315px;
    pointer-events: initial;
  }
  .vert {
    max-height: calc(90vh - 190px);
    /* margin-top: 60px;      */
  }
  
}

@media screen and (max-width: 768px){
  padding-top: 90px;
  h1 {
    font-size: 35px;
    line-height: 1.025em;
  }
  div h2 {
    line-height: 1.8em;
  }
}
`;





export const CarouselContainer = styled.div`
  position: fixed;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0.6;
  line-height: 12px;
  font-size: 10px;
  font-family: "Sackers";
  letter-spacing: .15rem;
  z-index: 80;
`;

export const Counter = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 12px;
  font-size: 10px;
  font-family: "Sackers";
  letter-spacing: 2px;
  z-index: 80;
  bottom: 31px;
  left: 0;
  right: 0;
  margin: 0 auto;
  @media screen and (max-width: 768px){
    bottom: 28px;
  }
`;

export const ChevronBtn = styled.span`
  cursor: pointer;
  padding: 0 10px;
  font-size: 18px;
  opacity: 0.5;
  transition: opacity 0.2s ease;
  user-select: none;
  &:hover { opacity: 1; }
`;


export const PostTitle = styled.div`
/* margin: auto; */
position: fixed;
line-height: 15px;
font-size: 10px;
font-family: "Sackers";
letter-spacing: 2px;
z-index: 80;
bottom: 30px;
left: 30px;
text-transform: uppercase;  
white-space: nowrap;
width: 20vw;
overflow: hidden;
text-overflow: ellipsis;
word-break: break-all;
text-align: left;
transition: width 200ms ease-in;
&:hover {
  width: 100%;
  max-width: 40vw;
 
}
@media screen and (max-width: 768px){
  width: 30vw;
  text-align: left;
  bottom: 27px;
  left: 15px;
}
@media screen and (max-device-width: 768px){

  bottom: 27px;
  left: 15px;
}
`;

export const Next = styled.div`
  width: 50vw;
  position: fixed;
  right:0;
  top:0;
  height: calc(100vh - 90px);
  /* cursor: e-resize; */
  cursor: none;
  z-index:99;
  @media screen and (max-width: 768px){
    height: calc(60vh);
    top: 20vh;
    width: 25vw;
    z-index: 100;
  }
`;

export const Prev = styled.div`
width: 50vw;
  position: fixed;
  left:0;
  top: 45px;
  height: calc(100vh - 90px);
  /* cursor: w-resize; */
  cursor: none;
  z-index:99;
  @media screen and (max-width: 768px){
    height: calc(60vh);
    top: 25vh;
    width: 25vw;
    z-index: 99;
  }
`;

export const NextProject = styled.div`
  /* margin: auto; */
  position: fixed;
  line-height: 13px;
  font-size: 10px;
  font-family: "Sackers";
  letter-spacing: 2px;
  z-index: 80;
  bottom: 22px;
  right: 30px;
  text-transform: uppercase;
  color: white;
  a {
    white-space: nowrap;
    max-width: 20vw;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    text-align: right;
    transition: width 100ms ease-in;
    &:hover {
      max-width: 100%;
      h3 {
        visibility: visible;
         width: auto;
         opacity: 1;
      }
      @media screen and (min-width: 768px) {
        color: transparent;
        span {
          color: transparent;
        }
      }
    
    }
  }

  a, h3 {
      line-height: 13px;
      font-size: 10px !important;
      font-family: "Sackers";
      letter-spacing: 2px;
      text-transform: uppercase;
      color: white;
      display: inline-block;
    }
  h3 {
    transition: 250ms;
    visibility: hidden;
    width: 0;
    opacity: 0;
  }
  @media screen and (max-width: 768px){
    h3 {
      display:none;
      
    }
    a {
      line-height: 14px;
      max-width: 31vw;
      width: 31vw;
    }
    a:hover {
      width: initial;
    }
    bottom: 27px;
    right: 15px;
    vertical-align: bottom;
    line-height: initial;
  }

`;

export const TextandLink = styled.p`
  p {
    margin-bottom: 0;
    margin-top:0;
    padding-top: 15px;
    display: inline;
  }
  p:first-child {
    margin-top: 0px;
  }
  a {
    color:white;
    padding: 0 5px;
    text-decoration: underline; 
  }
  z-index: 999 !important;
  position: relative;
`;
